export default __webpack_public_path__ + "static/media/ic_austria.abe11565.svg";